import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectAllNodes, selectAllPoints } from '../map/slice/mapSelectors';
import { useFitMap } from '../plotter/usePanMap';

export const useFocusZone = () => {
  const fitMap = useFitMap();
  const dispatch = useDispatch();

  const points = useSelector(selectAllPoints);
  const nodes = useSelector(selectAllNodes);

  const focusZone = useCallback(
    (zoneId: string | number | null | undefined) => {
      if (!zoneId) {
        return false;
      }
      const zoneNodes = Object.values(points)
        .filter((point) => point.delivery_zone === zoneId)
        .map((point) => {
          return nodes[point?.node ?? ''];
        })
        .filter((node) => node !== undefined);

      if (zoneNodes.length === 0) {
        return false;
      }

      fitMap(zoneNodes);
      return true;
    },
    [dispatch, nodes, fitMap, points],
  );

  return focusZone;
};
